import { render, staticRenderFns } from "./KeyboardIcon.vue?vue&type=template&id=bd33fda8&"
import script from "./KeyboardIcon.vue?vue&type=script&lang=js&"
export * from "./KeyboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports